// extracted by mini-css-extract-plugin
module.exports = {"footer":"DetailsFooter__footer___DOxCL","requestActions":"DetailsFooter__requestActions___NBRcm"};